import { FC, useState } from "react";
import {
  ProductSVG,
  primaryPackageSVG,
  primarySelectedIconSVG,
  serviceSVG,
} from "../../../../assets/SVGs/SVGs";
import { useIntl } from "react-intl";
import { Avatar, Modal, Popover } from "antd";
import { FaRegUser } from "react-icons/fa";
import { appointmentDetails } from "../../../../types/calendar";
import { UserOutlined } from "@ant-design/icons";
import LoyaltyDiscount from "./LoyaltyDiscount";
import dayjs from "dayjs";
import { getPaymentMethods } from "../../../../network/settings";
import ChangePaymentMethod from "../AppointmentDetails/ChangePaymentMethod";
import { updateAppointment } from "../../../../network/calendar";

interface ReservationDetailsProps {
  appointment: appointmentDetails;
}

const ReservationDetails: FC<ReservationDetailsProps> = ({ appointment }) => {
  const intl = useIntl();
  const [openModal, setOpenModal] = useState(false);
  const totalWithoutTax =
    appointment?.appointment_services?.reduce(
      (sum, service) => sum + Number(service?.pricing_option?.price),
      0
    ) +
    appointment?.appointment_packages?.reduce(
      (sum, pkg) => sum + Number(pkg?.package?.retail_price),
      0
    ) +
    appointment?.products?.reduce(
      (sum, product) => sum + Number(product?.retail_price),
      0
    );

  const canEdit = (): boolean => {
    if (dayjs(appointment?.date).isBefore(dayjs())) {
      return false;
    }
    if (
      appointment?.status === "canceled" ||
      appointment?.status === "completed"
    ) {
      return false;
    } else {
      return true;
    }
  };
  const updatePaymentMethod = async (paymentMethodId: number) => {
    return updateAppointment(appointment?.location_id, appointment?.id, {
      payment_method_id: paymentMethodId,
    });
  };
  let fixedDiscount = 0;
  if (appointment?.discount && Number(appointment?.discount) > 0) {
    if (appointment?.discount_type === "fixed") {
      fixedDiscount += +appointment?.discount;
    }
    if (appointment?.discount_type === "percentage") {
      fixedDiscount += (totalWithoutTax * +appointment?.discount) / 100;
    }
  }
  let totalPriceWithDiscount = totalWithoutTax - fixedDiscount;
  let taxValue = Number(
    +totalPriceWithDiscount * (+appointment?.taxable?.tax_rate / 100)
  ).toFixed(2);
  return (
    <div className="space-y-2 py-2">
      <p className="text-sm font-bold text-[#00086D]">
        {intl.formatMessage({
          id: "appointmentDetails",
          defaultMessage: "تفاصيل الحجز",
        })}
      </p>
      <div className="bg-[#FBFBFF] p-2 rounded flex gap-2">
        <p>
          <FaRegUser color="#00086D" size={15} />
        </p>
        <p>
          {appointment?.appointmentable?.first_name +
            " " +
            appointment?.appointmentable?.last_name}
        </p>
      </div>
      <div className="grid grid-cols-2 gap-2">
        {appointment?.appointment_services?.map((service, i) => {
          return (
            <div className="flex gap-2  col-span-1 bg-[#FBFBFF] p-2 rounded ">
              <Popover content={service?.team_member?.name}>
                <Avatar
                  size={25}
                  src={service?.team_member?.media}
                  className="bg-color-primary"
                  icon={<UserOutlined />}
                ></Avatar>
              </Popover>

              <p>{serviceSVG}</p>
              <p>{service?.service?.name}</p>
            </div>
          );
        })}
      </div>
      <div className="grid grid-cols-2 gap-2">
        {appointment?.appointment_packages?.map((pkg, i) => {
          return (
            <div className="flex gap-2  col-span-1 bg-[#FBFBFF] p-2 rounded ">
              <Popover content={pkg?.team_member?.name}>
                <Avatar
                  size={25}
                  src={pkg?.team_member?.media}
                  className="bg-color-primary"
                  icon={<UserOutlined />}
                ></Avatar>
              </Popover>

              <span>{primaryPackageSVG}</span>
              <p>{pkg?.package?.name}</p>
            </div>
          );
        })}
      </div>
      <div className="grid grid-cols-2 gap-2">
        {appointment?.products?.map((product) => {
          return (
            <div className="flex gap-2 col-span-1 bg-[#FBFBFF] p-2 rounded">
              <p>{ProductSVG}</p>
              <p>{product?.name}</p>
            </div>
          );
        })}
      </div>
      {appointment?.loyalty_program_range ? (
        <LoyaltyDiscount
          loyaltyDiscount={{
            amount: totalWithoutTax,
            percentage: Number(
              appointment?.loyalty_program_range?.discount_percentage
            ),
          }}
        />
      ) : null}
      <div className="p-2 rounded  bg-[#EEF0FF]">
        <div className="flex gap-2    p-2 justify-between rounded">
          <p className="flex gap-2 items-center">
            <span>{intl.formatMessage({ id: "subTotal" })}</span>
          </p>

          <p className="flex gap-1 items-center ">
            <span className="text-color-primary font-semibold">
              {Number(totalWithoutTax).toFixed(2)}
            </span>
            <small className="text-xs self-center mt-2">
              {intl.formatMessage({
                id: "SARshort",
                defaultMessage: "ر.س",
              })}
            </small>
          </p>
        </div>

        {appointment?.discount && Number(appointment?.discount) > 0 ? (
          <div className="flex gap-2    p-2 justify-between rounded">
            <p className="flex gap-2 items-center">
              <span>{intl.formatMessage({ id: "discount" })}</span>
            </p>

            <p className="flex gap-1 items-center ">
              <span className="text-color-primary font-semibold text-red-600">
                -
                {appointment?.discount_type === "fixed"
                  ? Number(appointment?.discount).toFixed(2)
                  : Number(
                      (+totalWithoutTax * +appointment?.discount) / 100
                    ).toFixed(2)}
              </span>
              <small className="text-xs self-center mt-2">
                {intl.formatMessage({
                  id: "SARshort",
                  defaultMessage: "ر.س",
                })}
              </small>
              {appointment?.discount_type === "percentage" ? (
                <span className="text-color-primary font-semibold text-red-600">
                  {"( "}
                  {Number(appointment?.discount).toFixed()}%{" )"}
                </span>
              ) : null}
            </p>
          </div>
        ) : null}
        <div className="flex gap-2    p-2 justify-between rounded">
          <p className="flex gap-2 items-center">
            <span>{intl.formatMessage({ id: "tax" })}</span>
          </p>

          <p className="flex gap-1 items-center ">
            <span className="text-color-primary font-semibold">{taxValue}</span>
            <small className="text-xs self-center mt-2">
              {intl.formatMessage({
                id: "SARshort",
                defaultMessage: "ر.س",
              })}
            </small>
            <span className="">
              {"( " + Number(appointment?.taxable?.tax_rate).toFixed() + "% )"}
            </span>
          </p>
        </div>
        <div className="w-11/12 mx-auto bg-slate-300 px-10 h-[1px]" />

        <div className="flex gap-2   p-2 justify-between rounded">
          <p className="flex gap-2 items-center">
            <span className="">
              {intl.formatMessage({
                id: "totalPrice",
                defaultMessage: "الحساب الكلي",
              })}
            </span>
          </p>

          <p className="flex gap-1 items-center ">
            <span className="text-color-primary font-semibold">
              {Number(Number(appointment?.cost)).toFixed(2)}
            </span>
            <small className="text-xs self-center mt-2">
              {" "}
              {intl.formatMessage({
                id: "SARshort",
                defaultMessage: "ر.س",
              })}
            </small>
          </p>
        </div>

        <div className="flex gap-2   p-2 justify-between rounded">
          <p className="flex gap-2 items-center">
            <span className="">
              {intl.formatMessage({
                id: "payWith",
                defaultMessage: "الدفع من خلال",
              })}
            </span>
          </p>

          <p className="flex gap-1 items-center h-[34px] ">
            {appointment?.payment_method ? (
              <span className="text-color-primary font-semibold self-end">
                {primarySelectedIconSVG}
              </span>
            ) : null}
            <span className="text-color-primary font-semibold">
              {appointment?.payment_method?.name}
            </span>
            {canEdit() ? (
              <span
                className="text-[#5F72FF] cursor-pointer"
                onClick={() => setOpenModal(true)}
              >
                {" ( "} {intl.formatMessage({ id: "change" })} {")"}
              </span>
            ) : null}
          </p>
        </div>
      </div>
      {canEdit() ? (
        <Modal
          width={600}
          open={openModal}
          footer={null}
          onCancel={() => setOpenModal(false)}
          centered
          destroyOnClose
        >
          <ChangePaymentMethod
            setPaymentMethod={() => {}}
            paymentMethod={
              appointment?.payment_method ? appointment?.payment_method : null
            }
            updatePaymentMethod={updatePaymentMethod}
            getPaymentMethods={getPaymentMethods}
            onCancel={() => setOpenModal(false)}
            queryKey={["appointment"]}
          />
        </Modal>
      ) : null}
      {/* <div className="grid grid-cols-6 gap-2">
        {appointment?.paymentMethod === "creditCard" ? (
          <>
            <div className="col-span-4 h-fit bg-[#EEF0FF] rounded p-2">
              <div className="my-2  space-y-2 text-sm">
                <p className="text-gray-400 text-sm text-end">
                  <span> {infoSVG} </span>
                  <span>
                    {intl.formatMessage({
                      id: "sendPaymentLink",
                      defaultMessage:
                        " عند الضغط على ارسال، سيتم ارسال رابط الدفع الى العميل",
                    })}
                  </span>
                </p>
                <div className="flex justify-between gap-1 items-center">
                  <Button
                    type="text"
                    htmlType="button"
                    onClick={handleSendPaymentUrl}
                  >
                    <span>{sendIconSVG}</span>
                  </Button>

                  <Button
                    type="default"
                    htmlType="button"
                    className="  flex justify-between gap-1 overflow-hidden"
                    onClick={() => {
                      navigator.clipboard.writeText(
                        appointment?.paymentUrl || ""
                      );
                      message.success(
                        intl.formatMessage({
                          id: "linkCopied",
                          defaultMessage: "تم نسخ الرابط",
                        })
                      );
                    }}
                  >
                    <p className="text-sm overflow-hidden">
                      {appointment?.paymentUrl}
                    </p>
                    <span>{copyIconSVG}</span>
                  </Button>
                </div>
              </div>
            </div>
            <div className="col-span-2 bg-[#EEF0FF] rounded p-2">
              {appointment?.paymentUrl ? (
                <div
                  id="myqrcode"
                  className="mx-auto flex flex-col justify-center items-center rounded bg-[#EEF0FF] w-fit"
                >
                  <QRCode
                    value={appointment?.paymentUrl}
                    bgColor="#EEF0FF"
                    color="#00086D"
                  />
                  <Button
                    type="text"
                    className="text-color-primary font-semibold"
                    onClick={downloadQRCode}
                  >
                    تحميل الكود
                  </Button>
                </div>
              ) : null}
            </div>
          </>
        ) : null}
      </div> */}
    </div>
  );
};

export default ReservationDetails;
